import React from "react"
import cx from "classnames"
import "./index.scss"

const Text = ({ type, text, customClassName }) => {
  let styleClass = ""
  switch (type) {
    case "label":
      styleClass = "-label"
      break
    case "paragraph":
      styleClass = "-paragraph"
      break
    case "headline":
      styleClass = "-headline"
      break;
    case "subtitle":
      styleClass = "-subtitle"
      break;
    default:
      break
  }
  return (
    <>
      {type === "headline" ? (
        <h1
          className={cx(customClassName, "text", {
            [`${styleClass}`]: type,
          })}
        >
          {text}
        </h1>
      ) : (
        <p
          className={cx(customClassName, "text", {
            [`${styleClass}`]: type,
          })}
        >
          {text}
        </p>
      )}
    </>
  )
}

export default Text
